import React from 'react'
import PosterJurisdictionIcon from './PosterJurisdictionIcon'
import { StyledPosterContainer } from './styles'

const CityCountyPosterCell = ({ posters }) => {
  const cityPoster = posters.find((poster) => poster.jurisdictionInformation.jurisdictionType === 'City')
  const countyPoster = posters.find((poster) => poster.jurisdictionInformation.jurisdictionType === 'County')

  return (
    <StyledPosterContainer>
      {cityPoster && (
        <PosterJurisdictionIcon type="city" title={cityPoster.jurisdictionInformation.jurisdictionName} />
      )}
      {countyPoster && (
        <PosterJurisdictionIcon type="county" title={countyPoster.jurisdictionInformation.jurisdictionName} />
      )}
    </StyledPosterContainer>
  )
}

export default CityCountyPosterCell
